React = require 'react'
$ = require 'jquery'
Auth = require 'db/auth'
Controller = require 'controller'
CreateBoardComponent = require 'views/board-create/create-board-component'
Dialog = require 'views/lib/dialog'
getExperiment = require 'lib/experiments/simple-test'
Util = require 'lib/util'
View = require 'view'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'
template = require 'views/templates/boards_sidebar_searching_buttons'
track = require 'debug/track'

module.exports = class BoardsSidebarSearchingButtonsView extends View
  initialize: ({ searchText }) ->
    @searchText = searchText.map((text) -> text.trim())

  events:
    'click .js-add-board-with-name': 'addBoardWithName'

  renderOnce: ->
    @$el.html template()

    @subscribe @searchText, (text) ->
      @$('.js-add-board-with-name').format 'add board named', { boardName: text }

    @

  addBoardWithName: (e) ->
    Util.stop(e)

    track("Boards Drawer", "Add Board - With Name")

    if maybeDisplayMemberLimitsError($(e.target), null, Auth.me())
      return

    searchText = @searchText.get()

    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultTitle: searchText
        defaultOrg: Controller.getCurrentOrganization()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-searching-buttons-view.coffee